import { MouseEvent, useEffect, useRef, useState } from 'react'
import { Cover, Vector } from '../../../../../entity'
import './draw-freehand.scss'

interface DrawFreehandProps {
    width: number
    height: number
    widthRaito: number
    onDrawEnd: CallableFunction
}

export const DrawFreehand = (props: DrawFreehandProps) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null)
    const contextRef = useRef<CanvasRenderingContext2D | null>(null)

    const [isDrawing, setIsDrawing] = useState(false)
    const [points, setPoints] = useState<Vector[]>([])

    useEffect(() => {
        if (!canvasRef.current) {
            return
        }
        const canvas = canvasRef.current
        canvas.width = props.width
        canvas.height = props.height

        canvas.style.width = props.width + 'px'
        canvas.style.height = props.height + 'px'

        const context = canvas!!.getContext('2d')
        context!!.lineCap = 'round'
        context!!.lineJoin = 'round'
        context!!.strokeStyle = 'white'
        context!!.lineWidth = 20

        contextRef.current = context
    }, [])

    const onStart = (event: MouseEvent) => {
        const { offsetX, offsetY } = event.nativeEvent

        if (canvasRef.current) {
            canvasRef.current.style.width = props.width + 'px'
            canvasRef.current.style.height = props.height + 'px'
        }

        if (contextRef.current) {
            contextRef.current.lineCap = 'round'
            contextRef.current.lineJoin = 'round'
            contextRef.current.strokeStyle = 'white'
            contextRef.current.fillStyle = '#fff'
            contextRef.current.lineWidth = 20

            contextRef.current.beginPath()

            contextRef.current.moveTo(offsetX - 2, offsetY - 1)
            contextRef.current.lineTo(offsetX - 2, offsetY - 1)
            contextRef.current.stroke()

            const point = new Vector()
            point.x = offsetX / props.widthRaito
            point.y = offsetY / props.widthRaito
            point.flags = '[]'

            setPoints((prevPoints) => [...prevPoints, point])
        }
        setIsDrawing(true)

        event.preventDefault()
    }

    const onDraw = (event: MouseEvent) => {
        if (!isDrawing) {
            return
        }

        const { offsetX, offsetY } = event.nativeEvent

        if (contextRef.current) {
            contextRef.current.lineCap = 'round'
            contextRef.current.lineJoin = 'round'
            contextRef.current.strokeStyle = 'white'
            contextRef.current.fillStyle = '#fff'
            contextRef.current.lineWidth = 20

            contextRef.current.lineTo(offsetX - 2, offsetY - 1)
            contextRef.current.stroke()

            const point = new Vector()
            point.x = offsetX / props.widthRaito
            point.y = offsetY / props.widthRaito
            point.flags = '[]'

            setPoints((prevPoints) => [...prevPoints, point])
        }

        event.preventDefault()
    }

    const onStop = async () => {
        if (contextRef.current) {
            contextRef.current.closePath()

            if (isDrawing) {
                const cover = new Cover()
                cover.id = Math.random()
                cover.type = 3

                let left: number = -1;
                let right: number = -1;
                let bottom: number = -1;
                let top: number = -1;

                for (const point of points) {
                    if (point.flags === '[SPACER]') {
                        continue;
                    }
                    if (left === -1 || left > point.x) {
                        left = point.x;
                    }
                    if (top === -1 || top > point.y) {
                        top = point.y;
                    }
                    if (right === -1 || right < point.x) {
                        right = point.x;
                    }
                    if (bottom === -1 || bottom < point.y) {
                        bottom = point.y;
                    }
                }

                const position = new Vector()
                position.x = left // (left - 20) + ((right + 20) - (left - 20)) / 2
                position.y = top // (top - 20) + ((bottom + 20) - (top - 20)) / 2
                cover.position = position

                cover.width = (right - left) + 100
                cover.height = (bottom - top) + 100
                cover.radius = 0
                cover.rotation = 0

                cover.points = points

                const point = new Vector()
                point.x = 0
                point.y = 0
                point.flags = '[SPACER]'

                cover.points.push(point)

                cover.created = 0
                cover.updated = 0

                props.onDrawEnd(cover)

                setPoints((prevPoints) => [])

                contextRef.current.clearRect(0, 0, props.width, props.height)
            }
        }
        setIsDrawing(false)
    }

    const saveImageToLocal = (nativeEvent: MouseEvent) => {
        //     let link = event.currentTarget
        //     link.setAttribute('download', 'canvas.png')
        //     if (canvasRef.current) {
        //         let image = canvasRef.current.toDataURL('image/png')
        //         link.setAttribute('href', image)
        //     }
    }

    return (
        <div className="draw-freehand">
            <canvas className="canvas" ref={canvasRef} onMouseDown={onStart} onMouseMove={onDraw} onMouseUp={onStop} onMouseLeave={onStop} height={props.height} width={props.width}></canvas>
        </div>
    )
}
